import styled, { CSSProp } from 'styled-components';

export const HorizontalCard = styled.section<{ url?: string }>`
  max-width: 540px;
  height: 540px;
  width: 50%;
  background: ${({ url }): CSSProp => (url && `url(${url})`) || 'white'};
  display: flex;
  background-position: center;
  background-size: cover;
  justify-content: center;
  align-items: center;
  padding: 10px;
  @media screen and (max-width: 1200px) {
    width:100%;
    box-sizing: border-box;
    margin: 0 auto;
  }
`;

export const HorizontalCardInnerWrapper = styled.article`
  max-width: 414px;
  @media screen and (max-width: 1200px) {
    width: 100%;
    margin: 0 auto;
  }
`;

interface HorizontalCardFullPageProp {
  url: string;
  side?: string;
}

export const HorizontalCardFullPage = styled.section<HorizontalCardFullPageProp>`
  width: 100%;
  height: 540px;
  background: url(${({ url }) => (url && url) || ''});
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: ${({ side }) => (side && side) || 'flex-end'};
  padding: 40px;
  box-sizing: border-box;
  @media screen and (max-width: 1200px) {
    width:100%;
    margin: 0 auto;
    height: auto;
    padding: 20px;
  }
`;

export const HorizontalCardInnerFullPage = styled.article`
  height: 460px;
  width: 460px;
  padding: 0 79px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  @media screen and (max-width: 1200px) {
    width:100%;
    margin: 0 auto;
    height: auto;
    padding: 20px 20px;
  }
`;
